import { render, staticRenderFns } from "./PolyIntegerReferenceCreateScreen.vue?vue&type=template&id=3ba39e4e&"
import script from "./PolyIntegerReferenceCreateScreen.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports